<template>
<div class="chapter">
<div class="inner_page">
<div id="Abbreviations">
<p class="fm-title"><a id="page_x">Abbreviations</a></p><a id="page_x">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="2%"/>
<col width="98%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="abb-para">A.Tk</p></td>
<td align="left" valign="top"><p class="abb-para1">Anti-tank</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AA</p></td>
<td align="left" valign="top"><p class="abb-para1">Anti-aircraft</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ABDA</p></td>
<td align="left" valign="top"><p class="abb-para1">American-British-Dutch-Australian [Command]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AC</p></td>
<td align="left" valign="top"><p class="abb-para1">Army Co-Operation</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ADC</p></td>
<td align="left" valign="top"><p class="abb-para1">Aide-De-Camp</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ADMS</p></td>
<td align="left" valign="top"><p class="abb-para1">Assistant Director Medical Services</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ADOS</p></td>
<td align="left" valign="top"><p class="abb-para1">Assistant Director of Ordnance Services</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Adv.</p></td>
<td align="left" valign="top"><p class="abb-para1">Advance</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AFC</p></td>
<td align="left" valign="top"><p class="abb-para1">Air Force Cross</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AHQ</p></td>
<td align="left" valign="top"><p class="abb-para1">Army Headquarters</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ALG</p></td>
<td align="left" valign="top"><p class="abb-para1">Advanced Landing Ground</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AOC</p></td>
<td align="left" valign="top"><p class="abb-para1">Air Officer Commanding</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AOC in C</p></td>
<td align="left" valign="top"><p class="abb-para1">Air Officer Commanding-in-Chief</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Armd</p></td>
<td align="left" valign="top"><p class="abb-para1">Armoured</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ARP</p></td>
<td align="left" valign="top"><p class="abb-para1">Air Raid Precautions</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AVG</p></td>
<td align="left" valign="top"><p class="abb-para1">American Volunteer Group</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">AVM</p></td>
<td align="left" valign="top"><p class="abb-para1">Air Vice Marshal</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BAF</p></td>
<td align="left" valign="top"><p class="abb-para1">Burma Auxiliary Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BAFSEA</p></td>
<td align="left" valign="top"><p class="abb-para1">British Air Force South-East Asia</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Bde</p></td>
<td align="left" valign="top"><p class="abb-para1">Brigade</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BESA</p></td>
<td align="left" valign="top"><p class="abb-para1">Bengal Entertainment for the Services Association</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BGS</p></td>
<td align="left" valign="top"><p class="abb-para1">Brigadier, General Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BHC</p></td>
<td align="left" valign="top"><p class="abb-para1">Burma Hospital Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Bn./Btn.</p></td>
<td align="left" valign="top"><p class="abb-para1">Battalion</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BORs</p></td>
<td align="left" valign="top"><p class="abb-para1">British Other Ranks</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BRNVR</p></td>
<td align="left" valign="top"><p class="abb-para1">Burma Royal Naval Volunteer Reserve</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">BT</p></td>
<td align="left" valign="top"><p class="abb-para1">Bomber Transport</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Bty.</p></td>
<td align="left" valign="top"><p class="abb-para1">Battery</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CAO</p></td>
<td align="left" valign="top"><p class="abb-para1">Civil Affairs Officer</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CATF</p></td>
<td align="left" valign="top"><p class="abb-para1">Chinese-American Task Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CB</p></td>
<td align="left" valign="top"><p class="abb-para1">Companion of the Order of Bath</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CBE</p></td>
<td align="left" valign="top"><p class="abb-para1">Commander of the Most Excellent Order of the British Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CCAO</p></td>
<td align="left" valign="top"><p class="abb-para1">Chief Civil Affairs Officer</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CCS</p></td>
<td align="left" valign="top"><p class="abb-para1">Casualty Clearing Station</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para"><a id="page_xi">CIE</a></p></td>
<td align="left" valign="top"><p class="abb-para1">Companion of The Most Eminent Order of the Indian Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CIGS</p></td>
<td align="left" valign="top"><p class="abb-para1">Chief of the Imperial General Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CinC/C-in-C</p></td>
<td align="left" valign="top"><p class="abb-para1">Commander-in-Chief</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CGS</p></td>
<td align="left" valign="top"><p class="abb-para1">Chief of the General Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CMG</p></td>
<td align="left" valign="top"><p class="abb-para1">Companion of the Most Distinguished Order of Saint Michael and Saint George</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">COS</p></td>
<td align="left" valign="top"><p class="abb-para1">Chiefs of Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CSI</p></td>
<td align="left" valign="top"><p class="abb-para1">Companion of the Order of the Star of India</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">CVO</p></td>
<td align="left" valign="top"><p class="abb-para1">Commander of the Royal Victorian Order</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">cwt.</p></td>
<td align="left" valign="top"><p class="abb-para1">Centum Weight (or hundredweight)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DADMS</p></td>
<td align="left" valign="top"><p class="abb-para1">Deputy Assistant Director Medical Services</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DCO</p></td>
<td align="left" valign="top"><p class="abb-para1">Director Combined Operations</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DG</p></td>
<td align="left" valign="top"><p class="abb-para1">Director General</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Div.</p></td>
<td align="left" valign="top"><p class="abb-para1">Division</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DMS</p></td>
<td align="left" valign="top"><p class="abb-para1">Director Medical Services</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DSO</p></td>
<td align="left" valign="top"><p class="abb-para1">Distinguished Service Order</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">DWR</p></td>
<td align="left" valign="top"><p class="abb-para1">Duke of Wellington’s Regiment</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">E&amp;ME</p></td>
<td align="left" valign="top"><p class="abb-para1">Electrical and Mechanical Engineers</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ECO</p></td>
<td align="left" valign="top"><p class="abb-para1">Emergency Commissioned Officers</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">EI</p></td>
<td align="left" valign="top"><p class="abb-para1">East Indian</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Fd.</p></td>
<td align="left" valign="top"><p class="abb-para1">Field</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">FFR</p></td>
<td align="left" valign="top"><p class="abb-para1">Frontier Force Regiment</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GBE</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Grand Cross of the Most Excellent Order of the British Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GCB</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Grand Cross of The Most Honourable Order of the Bath</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GCIE</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Grand Commander of The Most Eminent Order of the Indian Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GCO</p></td>
<td align="left" valign="top"><p class="abb-para1">Governor’s Commissioned Officer</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GCSI</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Grand Commander of The Most Exalted Order of the Star of India</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GHQ</p></td>
<td align="left" valign="top"><p class="abb-para1">General Headquarters</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GOC</p></td>
<td align="left" valign="top"><p class="abb-para1">General Officer Commanding</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GOC in C</p></td>
<td align="left" valign="top"><p class="abb-para1">General Officer Commanding-in-Chief</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GP</p></td>
<td align="left" valign="top"><p class="abb-para1">General Purpose</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GPT</p></td>
<td align="left" valign="top"><p class="abb-para1">General Purpose Transport</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GR</p></td>
<td align="left" valign="top"><p class="abb-para1">General Reconnaissance/Gurkha Rifles</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">GS</p></td>
<td align="left" valign="top"><p class="abb-para1">General Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">HBM</p></td>
<td align="left" valign="top"><p class="abb-para1">His Britannic Majesty</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">HE</p></td>
<td align="left" valign="top"><p class="abb-para1">High Explosive/His Excellency</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">HM</p></td>
<td align="left" valign="top"><p class="abb-para1">His Majesty</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">HMG</p></td>
<td align="left" valign="top"><p class="abb-para1">His Majesty’s Government</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">HMIS</p></td>
<td align="left" valign="top"><p class="abb-para1">His Majesty’s Indian Ship</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para"><a id="page_xii">HMS</a></p></td>
<td align="left" valign="top"><p class="abb-para1">His Majesty’s Ship</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IAF</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Air Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IATC</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Air Training Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IEF</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Expeditionary Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IHC</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Hospital Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IMS</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Medical Service(s)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Ind.</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Inf.</p></td>
<td align="left" valign="top"><p class="abb-para1">Infantry</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Innisks.</p></td>
<td align="left" valign="top"><p class="abb-para1">Inniskilling</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IORs</p></td>
<td align="left" valign="top"><p class="abb-para1">Indian Other Rank(s)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">IWT</p></td>
<td align="left" valign="top"><p class="abb-para1">Inland Water Transport</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">JIC</p></td>
<td align="left" valign="top"><p class="abb-para1">Joint Intelligence Committee</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KBE</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of the Most Excellent Order of the British Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KCB</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of the Most Honourable Order of the Bath</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KCIE</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of The Most Eminent Order of the Indian Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KCMG</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of The Most Distinguished Order of Saint Michael and Saint George</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KCSI</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of The Most Exalted Order of the Star of India</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KCVO</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight Commander of The Royal Victorian Order</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KG</p></td>
<td align="left" valign="top"><p class="abb-para1">Knight of the Most Noble Order of the Garter</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">KOYLI</p></td>
<td align="left" valign="top"><p class="abb-para1">King’s Own Yorkshire Light Infantry</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">LAA</p></td>
<td align="left" valign="top"><p class="abb-para1">Light Anti-Aircraft</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">LCS</p></td>
<td align="left" valign="top"><p class="abb-para1">Landing Craft Support</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">LMG</p></td>
<td align="left" valign="top"><p class="abb-para1">Light Machine Gun</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">L of C</p></td>
<td align="left" valign="top"><p class="abb-para1">Line(s) of Communication</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">LRP</p></td>
<td align="left" valign="top"><p class="abb-para1">Long Range Penetration</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Lt.</p></td>
<td align="left" valign="top"><p class="abb-para1">Lieutenant</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">MC</p></td>
<td align="left" valign="top"><p class="abb-para1">Military Cross</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">MG</p></td>
<td align="left" valign="top"><p class="abb-para1">Major General/Machine-Gun</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">ML</p></td>
<td align="left" valign="top"><p class="abb-para1">Motor Launch</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">MMG</p></td>
<td align="left" valign="top"><p class="abb-para1">Medium Machine-Gun</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">MT</p></td>
<td align="left" valign="top"><p class="abb-para1">Motor Transport</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Mtn.</p></td>
<td align="left" valign="top"><p class="abb-para1">Mountain</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">MV, M/V</p></td>
<td align="left" valign="top"><p class="abb-para1">Motor Vessel</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">NAAFI</p></td>
<td align="left" valign="top"><p class="abb-para1">Navy, Army and Air Force Institutes</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">NCO</p></td>
<td align="left" valign="top"><p class="abb-para1">Non Commissioned Officer</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">NOIC</p></td>
<td align="left" valign="top"><p class="abb-para1">Naval Officer in Charge</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">NWFP</p></td>
<td align="left" valign="top"><p class="abb-para1">North-West Frontier Province</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">OBE</p></td>
<td align="left" valign="top"><p class="abb-para1">Most Excellent Order of the British Empire</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">OCTU</p></td>
<td align="left" valign="top"><p class="abb-para1">Officer Cadre Training Unit</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para"><a id="page_xiii">OP</a></p></td>
<td align="left" valign="top"><p class="abb-para1">Operation(s)/Observation Post</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">P&amp;T/P and T</p></td>
<td align="left" valign="top"><p class="abb-para1">Posts and Telegraphs</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">PAIC</p></td>
<td align="left" valign="top"><p class="abb-para1">Persia and Iraq Command</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">PC</p></td>
<td align="left" valign="top"><p class="abb-para1">Patrol Craft</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">pdr.</p></td>
<td align="left" valign="top"><p class="abb-para1">pounder</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">POL</p></td>
<td align="left" valign="top"><p class="abb-para1">Petrol, Oil, Lubricants</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">PRU</p></td>
<td align="left" valign="top"><p class="abb-para1">Photographic Reconnaissance Unit</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">QMG</p></td>
<td align="left" valign="top"><p class="abb-para1">Quartermaster General</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">R/T</p></td>
<td align="left" valign="top"><p class="abb-para1">Receiver-Transmitter/Radio Transmitter</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RA</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Artillery</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RAF</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Air Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RAOC</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Army Ordnance Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RASC</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Army Service Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RE</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Engineers</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Regt.</p></td>
<td align="left" valign="top"><p class="abb-para1">Regiment</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RGR</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Gurkha Rifles</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RHA</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Horse Artillery</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Rif.</p></td>
<td align="left" valign="top"><p class="abb-para1">Rifles</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RIN</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Indian Navy</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RN</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Navy</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">RTR</p></td>
<td align="left" valign="top"><p class="abb-para1">Royal Tank Regiment</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">SEAC</p></td>
<td align="left" valign="top"><p class="abb-para1">South East Asia Command</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">SS</p></td>
<td align="left" valign="top"><p class="abb-para1">Steam Ship</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">SSAFA</p></td>
<td align="left" valign="top"><p class="abb-para1">Soldiers’, Sailors’ and Airmen’s Families Association</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">SWPC</p></td>
<td align="left" valign="top"><p class="abb-para1">South-West Pacific Command</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">TB</p></td>
<td align="left" valign="top"><p class="abb-para1">Torpedo Bomber</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Tk</p></td>
<td align="left" valign="top"><p class="abb-para1">Tank</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">Tpt.</p></td>
<td align="left" valign="top"><p class="abb-para1">Transport</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">UOTC</p></td>
<td align="left" valign="top"><p class="abb-para1">University Officers Training Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">US</p></td>
<td align="left" valign="top"><p class="abb-para1">United States</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">USAAF</p></td>
<td align="left" valign="top"><p class="abb-para1">United States Army Air Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">WAAF</p></td>
<td align="left" valign="top"><p class="abb-para1">Women’s Auxiliary Air Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">WAC</p></td>
<td align="left" valign="top"><p class="abb-para1">Women’s Auxiliary Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">WET</p></td>
<td align="left" valign="top"><p class="abb-para1">War Equipment Table</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="abb-para">YMCA</p></td>
<td align="left" valign="top"><p class="abb-para1">Young Men’s Christian Association</p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?4ce2b75b